// Japanese-source keyed translation dictionary.
// t(japaneseString) returns the translation for the active language,
// falling back to the Japanese source when no translation exists.
export const DICT = {
  // ---- Landing page ----
  "無料で始める": { en: "Get started", pt: "Comece agora" },
  "ログインはこちら": { en: "Log in", pt: "Entrar" },
  "次世代の不動産管理クラウド": { en: "Next-generation property management cloud", pt: "Nuvem de gestão imobiliária de nova geração" },
  "物件・入居者・契約・家賃から": { en: "From properties, tenants, contracts and rent", pt: "De imóveis, inquilinos, contratos e aluguel" },
  "収支・投資分析まで、ひとつに。": { en: "to finance and investment analysis — all in one.", pt: "à análise financeira e de investimentos — tudo em um." },
  "煩雑な賃貸管理業務をクラウドで一元化。マルチテナント・RBAC・監査ログを備え、本番運用に耐える不動産管理SaaSです。": { en: "Centralize complex rental operations in the cloud. A production-ready property management SaaS with multi-tenancy, RBAC and audit logs.", pt: "Centralize operações de locação complexas na nuvem. Um SaaS de gestão imobiliária pronto para produção, com multi-tenancy, RBAC e logs de auditoria." },
  "主な機能": { en: "Key Features", pt: "Principais Recursos" },
  "賃貸経営に必要なすべての機能": { en: "Everything you need to run rentals", pt: "Tudo o que você precisa para gerir aluguéis" },
  "物件・部屋管理": { en: "Properties & Rooms", pt: "Imóveis e Unidades" },
  "物件カルテ、部屋・空室状況を一元管理。": { en: "Manage property records, rooms and vacancies in one place.", pt: "Gerencie fichas de imóveis, unidades e vagas em um só lugar." },
  "入居者・契約管理": { en: "Tenants & Contracts", pt: "Inquilinos e Contratos" },
  "入居者情報と契約更新をまとめて管理。": { en: "Manage tenant information and contract renewals together.", pt: "Gerencie dados de inquilinos e renovações de contrato juntos." },
  "家賃請求・入金・滞納": { en: "Billing, Payments & Arrears", pt: "Faturas, Pagamentos e Inadimplência" },
  "請求の自動生成から入金消込、滞納督促まで。": { en: "From auto-generated invoices to payment matching and arrears reminders.", pt: "De faturas geradas automaticamente à conciliação de pagamentos e cobranças." },
  "修繕・業者管理": { en: "Repairs & Vendors", pt: "Reparos e Fornecedores" },
  "修繕依頼のワークフローと業者を管理。": { en: "Manage repair workflows and vendors.", pt: "Gerencie fluxos de reparo e fornecedores." },
  "収支・投資分析": { en: "Finance & Analytics", pt: "Finanças e Análises" },
  "NOI・キャッシュフロー・利回りを可視化。": { en: "Visualize NOI, cash flow and yield.", pt: "Visualize NOI, fluxo de caixa e rentabilidade." },
  "ローン・書類・監査": { en: "Loans, Documents & Audit", pt: "Empréstimos, Documentos e Auditoria" },
  "返済予定・書類保管・操作ログを一元化。": { en: "Centralize repayment schedules, document storage and activity logs.", pt: "Centralize cronogramas de pagamento, documentos e logs de atividade." },
  "選ばれる理由": { en: "Why Neo", pt: "Por que Neo" },
  "運用を、もっとシンプルに。": { en: "Make operations simpler.", pt: "Torne a operação mais simples." },
  "クラウドで、いつでもどこでも": { en: "Cloud-based, anytime anywhere", pt: "Na nuvem, a qualquer hora e lugar" },
  "スマホ／PC対応。物件情報も収支もリアルタイムに把握できます。": { en: "Works on mobile and desktop. Track properties and finances in real time.", pt: "Funciona no celular e no computador. Acompanhe imóveis e finanças em tempo real." },
  "セキュリティを重視した設計": { en: "Security-first design", pt: "Projetado com segurança em primeiro lugar" },
  "マルチテナント分離・ロール権限・監査ログで安心の運用。": { en: "Peace of mind with tenant isolation, role-based access and audit logs.", pt: "Tranquilidade com isolamento por tenant, acesso por função e logs de auditoria." },
  "日本語標準・多言語対応": { en: "Japanese-first, multilingual", pt: "Japonês nativo, multilíngue" },
  "日本語をベースに英語・ポルトガル語にも対応。": { en: "Built around Japanese, with English and Portuguese support.", pt: "Baseado em japonês, com suporte a inglês e português." },
  "今日から、不動産管理をもっとスマートに。": { en: "Make property management smarter, starting today.", pt: "Torne a gestão imobiliária mais inteligente a partir de hoje." },
  "デモアカウントですぐにお試しいただけます。": { en: "Try it right away with a demo account.", pt: "Experimente agora com uma conta demo." },
  "クレジットカード不要": { en: "No credit card required", pt: "Sem cartão de crédito" },
  "日本語標準": { en: "Japanese by default", pt: "Japonês por padrão" },
  "マルチテナント対応": { en: "Multi-tenant ready", pt: "Pronto para multi-tenant" },
  "不動産管理SaaS": { en: "Property Management SaaS", pt: "SaaS de Gestão Imobiliária" },
  "すべての権利を留保します。": { en: "All rights reserved.", pt: "Todos os direitos reservados." },
  "詳しく見る": { en: "Learn more", pt: "Saiba mais" },
  "借主ポータル": { en: "Tenant Portal", pt: "Portal do Inquilino" },
  "借主ログイン": { en: "Tenant Login", pt: "Login do Inquilino" },
  "管理会社から発行されたコードと暗証番号でログインしてください。": { en: "Log in with the code and PIN issued by the management company.", pt: "Entre com o código e o PIN emitidos pela administradora." },
  "ログインコード": { en: "Login code", pt: "Código de acesso" },
  "暗証番号": { en: "PIN", pt: "PIN" },
  "ログアウト": { en: "Log out", pt: "Sair" },
  "デジタル賃貸契約": { en: "Digital Lease Agreement", pt: "Contrato de Locação Digital" },
  "あなたの契約": { en: "Your contracts", pt: "Seus contratos" },
  "契約を確認・署名": { en: "Review & sign", pt: "Revisar e assinar" },
  "内容を確認": { en: "View details", pt: "Ver detalhes" },
  "個人": { en: "Individual", pt: "Pessoa Física" },
  "法人": { en: "Corporate", pt: "Pessoa Jurídica" },
  "氏名": { en: "Full name", pt: "Nome completo" },
  "生年月日": { en: "Date of birth", pt: "Data de nascimento" },
  "住所": { en: "Address", pt: "Endereço" },
  "電話番号": { en: "Phone", pt: "Telefone" },
  "会社名": { en: "Company name", pt: "Nome da empresa" },
  "登記番号": { en: "Registration number", pt: "Número de registro" },
  "代表者名": { en: "Representative name", pt: "Nome do representante" },
  "担当者名": { en: "Contact person", pt: "Pessoa de contato" },
  "本人写真": { en: "Photo", pt: "Foto" },
  "担当者写真": { en: "Contact person photo", pt: "Foto do responsável" },
  "身分証明書（表）": { en: "ID (front)", pt: "Documento (frente)" },
  "身分証明書（裏）": { en: "ID (back)", pt: "Documento (verso)" },
  "画像を選択": { en: "Choose image", pt: "Escolher imagem" },
  "サイン": { en: "Signature", pt: "Assinatura" },
  "サインをクリア": { en: "Clear", pt: "Limpar" },
  "提出する": { en: "Submit", pt: "Enviar" },
  "提出しました": { en: "Submitted", pt: "Enviado" },
  "提出済み": { en: "Submitted", pt: "Enviado" },
  "承認済み": { en: "Approved", pt: "Aprovado" },
  "未提出": { en: "Not submitted", pt: "Não enviado" },
  "PDF出力": { en: "Export PDF", pt: "Exportar PDF" },
  "契約書PDF": { en: "Contract PDF", pt: "PDF do contrato" },
  "この契約は承認済みです": { en: "This contract has been approved.", pt: "Este contrato foi aprovado." },
  "読み込み中...": { en: "Loading...", pt: "Carregando..." },
  "契約がまだ登録されていません。": { en: "No contracts registered yet.", pt: "Nenhum contrato registrado ainda." },
  "月": { en: "mo", pt: "mês" },
  "物件": { en: "Property", pt: "Imóvel" },
  "ポータル発行": { en: "Issue access", pt: "Emitir acesso" },
  "PIN再発行": { en: "Reset PIN", pt: "Redefinir PIN" },
  "ログイン情報を発行しました": { en: "Login credentials issued", pt: "Credenciais emitidas" },
  "暗証番号はこの画面でのみ表示されます。借主にお伝えください。": { en: "The PIN is shown only on this screen. Share it with the tenant.", pt: "O PIN é exibido apenas nesta tela. Compartilhe com o inquilino." },
  "コピー": { en: "Copy", pt: "Copiar" },
  "コピーしました": { en: "Copied", pt: "Copiado" },
  "閉じる": { en: "Close", pt: "Fechar" },
  "提出内容の確認": { en: "Review submission", pt: "Revisar envio" },
  "提出内容が見つかりません": { en: "Submission not found", pt: "Envio não encontrado" },
  "承認する": { en: "Approve", pt: "Aprovar" },
  "承認しました": { en: "Approved", pt: "Aprovado" },
  "借主のログイン情報の発行と、提出されたデジタル契約の確認・承認": { en: "Issue tenant login credentials and review/approve submitted digital contracts.", pt: "Emita credenciais de inquilino e revise/aprove contratos digitais enviados." },
  "状態": { en: "Status", pt: "Status" },
  "提出内容": { en: "Submission", pt: "Envio" },
  "操作": { en: "Actions", pt: "Ações" },
  "有効": { en: "Active", pt: "Ativo" },
  "未発行": { en: "Not issued", pt: "Não emitido" },
  "入居者が登録されていません。": { en: "No tenants registered.", pt: "Nenhum inquilino registrado." },
  "物件ごとの基本情報・写真・設備を管理し、部屋単位で入居中／空室のステータスをリアルタイムに把握。ポートフォリオ全体を一目で確認できます。": { en: "Manage each property's details, photos and amenities, and track occupied/vacant status per room in real time — see your whole portfolio at a glance.", pt: "Gerencie detalhes, fotos e comodidades de cada imóvel e acompanhe o status ocupado/vago por unidade em tempo real — veja todo o portfólio de relance." },
  "入居者のプロフィールと連絡先、契約期間・賃料・更新条件を一元管理。更新期限が近づく契約を自動で可視化します。": { en: "Centralize tenant profiles and contacts with contract terms, rent and renewal conditions, and automatically surface contracts nearing renewal.", pt: "Centralize perfis e contatos de inquilinos com prazos de contrato, aluguel e condições de renovação, destacando automaticamente contratos próximos da renovação." },
  "毎月の請求書を自動生成し、入金を消込。滞納が発生した場合はステータス管理と督促の記録まで一気通貫で対応します。": { en: "Auto-generate monthly invoices and reconcile payments, with end-to-end arrears status tracking and reminder records.", pt: "Gere faturas mensais automaticamente e concilie pagamentos, com acompanhamento completo de inadimplência e registros de cobrança." },
  "入居者からの修繕依頼を受付から完了まで追跡。協力業者の情報と対応履歴もまとめて管理できます。": { en: "Track repair requests from intake to completion, and manage vendor information and service history together.", pt: "Acompanhe solicitações de reparo do início ao fim e gerencie informações de fornecedores e histórico de serviços." },
  "物件ごとのNOI・キャッシュフロー・表面／実質利回りを自動計算。投資判断に役立つ指標をダッシュボードで可視化します。": { en: "Automatically compute NOI, cash flow and gross/net yield per property, visualizing key investment metrics on a dashboard.", pt: "Calcule automaticamente NOI, fluxo de caixa e rentabilidade bruta/líquida por imóvel, visualizando métricas de investimento em um painel." },
  "借入の返済予定を管理し、契約書などの重要書類を安全に保管。すべての操作は監査ログに記録され、運用の透明性を担保します。": { en: "Manage loan repayment schedules and securely store key documents like contracts; every action is recorded in an audit log for full transparency.", pt: "Gerencie cronogramas de pagamento de empréstimos e armazene documentos importantes com segurança; cada ação é registrada em um log de auditoria para total transparência." },

  // ---- App / chrome ----
  "不動産管理システム": { en: "Property Management", pt: "Gestão Imobiliária" },
  "ダッシュボード": { en: "Dashboard", pt: "Painel" },
  "物件管理": { en: "Properties", pt: "Imóveis" },
  "物件一覧": { en: "Property List", pt: "Lista de Imóveis" },
  "部屋一覧": { en: "Rooms", pt: "Unidades" },
  "空室一覧": { en: "Vacancies", pt: "Vagas" },
  "入居者管理": { en: "Tenants", pt: "Inquilinos" },
  "契約管理": { en: "Contracts", pt: "Contratos" },
  "家賃管理": { en: "Rent", pt: "Aluguel" },
  "請求": { en: "Invoices", pt: "Faturas" },
  "入金": { en: "Payments", pt: "Pagamentos" },
  "滞納": { en: "Arrears", pt: "Inadimplência" },
  "修繕管理": { en: "Repairs", pt: "Reparos" },
  "業者管理": { en: "Vendors", pt: "Fornecedores" },
  "収支管理": { en: "P&L", pt: "Receitas/Despesas" },
  "ローン管理": { en: "Loans", pt: "Empréstimos" },
  "投資分析": { en: "Investment", pt: "Investimento" },
  "書類管理": { en: "Documents", pt: "Documentos" },
  "AIアシスタント": { en: "AI Assistant", pt: "Assistente IA" },
  "レポート": { en: "Reports", pt: "Relatórios" },
  "設定": { en: "Settings", pt: "Configurações" },
  "会社設定": { en: "Company", pt: "Empresa" },
  "ユーザー": { en: "Users", pt: "Usuários" },
  "権限": { en: "Roles", pt: "Permissões" },
  "通知": { en: "Notifications", pt: "Notificações" },
  "メール通知": { en: "Email Log", pt: "Registro de E-mail" },
  "監査ログ": { en: "Audit Log", pt: "Auditoria" },

  // ---- Common actions ----
  "新規登録": { en: "Add New", pt: "Adicionar" },
  "保存": { en: "Save", pt: "Salvar" },
  "キャンセル": { en: "Cancel", pt: "Cancelar" },
  "削除": { en: "Delete", pt: "Excluir" },
  "編集": { en: "Edit", pt: "Editar" },
  "詳細": { en: "Details", pt: "Detalhes" },
  "記録": { en: "Record", pt: "Registrar" },
  "選択してください": { en: "Please select", pt: "Selecione" },
  "ファイル選択": { en: "Choose file", pt: "Escolher arquivo" },
  "添付済み": { en: "Attached", pt: "Anexado" },
  "絞り込み検索...": { en: "Filter...", pt: "Filtrar..." },
  "データがありません": { en: "No data", pt: "Sem dados" },
  "削除の確認": { en: "Confirm deletion", pt: "Confirmar exclusão" },
  "このデータを削除しますか？この操作は取り消せません。": { en: "Delete this record? This cannot be undone.", pt: "Excluir este registro? Isto não pode ser desfeito." },
  "ログアウト": { en: "Log out", pt: "Sair" },
  "該当する結果がありません": { en: "No matching results", pt: "Nenhum resultado" },
  "この画面へのアクセス権限がありません": { en: "You do not have access to this page", pt: "Sem permissão para esta página" },
  "件": { en: "", pt: "" },
  "戸": { en: " units", pt: " un." },

  // ---- Login ----
  "ログイン": { en: "Sign in", pt: "Entrar" },
  "アカウント情報を入力してください": { en: "Enter your account credentials", pt: "Insira suas credenciais" },
  "メールアドレス": { en: "Email", pt: "E-mail" },
  "パスワード": { en: "Password", pt: "Senha" },
  "デモアカウント": { en: "Demo accounts", pt: "Contas demo" },
  "自動入力": { en: "Fill", pt: "Preencher" },
  "不動産管理を、": { en: "Property management,", pt: "Gestão imobiliária," },
  "ひとつのシステムで。": { en: "in one system.", pt: "em um só sistema." },
  "物件・入居者・契約・家賃・修繕・収支・投資分析まで。": { en: "Properties, tenants, contracts, rent, repairs, P&L and investment analysis.", pt: "Imóveis, inquilinos, contratos, aluguel, reparos, resultados e análise de investimento." },
  "すべての業務を一元管理する次世代の不動産管理プラットフォーム。": { en: "A next-generation platform to manage everything in one place.", pt: "Uma plataforma de nova geração para gerenciar tudo em um só lugar." },

  // ---- Dashboard ----
  "経営サマリー": { en: "business summary", pt: "resumo do negócio" },
  "クイックメニュー": { en: "Quick Menu", pt: "Menu rápido" },
  "ポートフォリオ概況": { en: "Portfolio Overview", pt: "Visão da Carteira" },
  "今月の収支": { en: "This Month's P&L", pt: "Resultado do Mês" },
  "対応が必要な項目 / アラート": { en: "Action Required / Alerts", pt: "Ações Necessárias / Alertas" },
  "所有物件数": { en: "Owned Properties", pt: "Imóveis Próprios" },
  "管理物件数": { en: "Managed Properties", pt: "Imóveis Geridos" },
  "総戸数": { en: "Total Units", pt: "Total de Unidades" },
  "入居戸数": { en: "Occupied Units", pt: "Unidades Ocupadas" },
  "空室数": { en: "Vacant Units", pt: "Unidades Vagas" },
  "入居率": { en: "Occupancy Rate", pt: "Taxa de Ocupação" },
  "今月家賃請求額": { en: "Rent Billed (Month)", pt: "Aluguel Faturado (Mês)" },
  "今月入金額": { en: "Received (Month)", pt: "Recebido (Mês)" },
  "未収金": { en: "Receivables", pt: "A Receber" },
  "今月ローン返済額": { en: "Loan Payment (Month)", pt: "Empréstimo (Mês)" },
  "今月修繕費": { en: "Repairs (Month)", pt: "Reparos (Mês)" },
  "今月経費": { en: "Expenses (Month)", pt: "Despesas (Mês)" },
  "今月キャッシュフロー": { en: "Cash Flow (Month)", pt: "Fluxo de Caixa (Mês)" },
  "滞納件数": { en: "Arrears Count", pt: "Inadimplências" },
  "契約更新予定": { en: "Renewals Due", pt: "Renovações" },
  "修繕対応中": { en: "Repairs In Progress", pt: "Reparos em Andamento" },
  "重要アラート": { en: "Key Alerts", pt: "Alertas Importantes" },

  // ---- Page headers ----
  "所有・管理する物件の一覧": { en: "Owned and managed properties", pt: "Imóveis próprios e geridos" },
  "物件を登録": { en: "Add Property", pt: "Adicionar Imóvel" },
  "部屋・区画管理": { en: "Rooms & Units", pt: "Unidades" },
  "各物件の部屋・区画と入居状況": { en: "Rooms/units and occupancy per property", pt: "Unidades e ocupação por imóvel" },
  "部屋を登録": { en: "Add Room", pt: "Adicionar Unidade" },
  "空室・募集中の部屋": { en: "Vacant and listed rooms", pt: "Unidades vagas e anunciadas" },
  "空室はありません": { en: "No vacancies", pt: "Sem vagas" },
  "入居者情報（個人情報は権限により管理）": { en: "Tenant records (PII access-controlled)", pt: "Cadastro de inquilinos (dados protegidos)" },
  "入居者を登録": { en: "Add Tenant", pt: "Adicionar Inquilino" },
  "賃貸借契約の一覧・更新管理": { en: "Lease contracts and renewals", pt: "Contratos de locação e renovações" },
  "契約を登録": { en: "Add Contract", pt: "Adicionar Contrato" },
  "家賃請求管理": { en: "Rent Billing", pt: "Faturamento de Aluguel" },
  "契約内容から家賃請求を管理": { en: "Manage rent invoices from contracts", pt: "Gerencie faturas a partir dos contratos" },
  "請求を追加": { en: "Add Invoice", pt: "Adicionar Fatura" },
  "今月分を自動生成": { en: "Auto-generate this month", pt: "Gerar do mês" },
  "入金管理": { en: "Payments", pt: "Pagamentos" },
  "家賃入金の記録": { en: "Record rent payments", pt: "Registrar pagamentos" },
  "入金を記録": { en: "Record Payment", pt: "Registrar Pagamento" },
  "入金記録がありません": { en: "No payments recorded", pt: "Nenhum pagamento" },
  "滞納管理": { en: "Arrears", pt: "Inadimplência" },
  "家賃未入金の滞納状況と督促履歴": { en: "Overdue rent and reminder history", pt: "Aluguel em atraso e histórico de cobrança" },
  "現在、滞納はありません": { en: "No arrears at the moment", pt: "Sem inadimplência no momento" },
  "督促記録": { en: "Add Reminder", pt: "Registrar Cobrança" },
  "督促を記録": { en: "Record Reminder", pt: "Registrar Cobrança" },
  "受付 → 見積 → 承認 → 発注 → 工事 → 完了 → 支払": { en: "Receive → Quote → Approve → Order → Work → Done → Pay", pt: "Receber → Orçar → Aprovar → Pedir → Obra → Concluir → Pagar" },
  "修繕を登録": { en: "Add Repair", pt: "Adicionar Reparo" },
  "修繕・工事業者の管理": { en: "Repair and construction vendors", pt: "Fornecedores de reparos e obras" },
  "業者を登録": { en: "Add Vendor", pt: "Adicionar Fornecedor" },
  "物件単位・会社単位の収支サマリー": { en: "P&L by property and company", pt: "Resultados por imóvel e empresa" },
  "不動産ごとの融資情報（行クリックで返済予定表）": { en: "Financing per property (click a row for the schedule)", pt: "Financiamento por imóvel (clique para o cronograma)" },
  "ローンを登録": { en: "Add Loan", pt: "Adicionar Empréstimo" },
  "不動産投資分析": { en: "Investment Analysis", pt: "Análise de Investimento" },
  "購入予定物件のシミュレーション（稼働率・金利で試算）": { en: "Simulate a target purchase (occupancy & rate)", pt: "Simule uma compra (ocupação e taxa)" },
  "契約書・登記簿・見積書などを物件と関連付けて保存": { en: "Store contracts, deeds, quotes linked to properties", pt: "Guarde contratos, escrituras e orçamentos por imóvel" },
  "書類をアップロード": { en: "Upload Document", pt: "Enviar Documento" },
  "書類がありません": { en: "No documents", pt: "Sem documentos" },
  "経営レポート（年間サマリー）": { en: "Management report (annual summary)", pt: "Relatório de gestão (resumo anual)" },
  "自社の基本情報": { en: "Company basic information", pt: "Informações da empresa" },
  "社内ユーザーと権限の管理": { en: "Manage users and roles", pt: "Gerenciar usuários e permissões" },
  "ユーザーを追加": { en: "Add User", pt: "Adicionar Usuário" },
  "権限設定": { en: "Roles", pt: "Permissões" },
  "ロールベースアクセス制御（RBAC）": { en: "Role-based access control (RBAC)", pt: "Controle de acesso por função (RBAC)" },
  "権限マトリクス": { en: "Permission matrix", pt: "Matriz de permissões" },
  "機能": { en: "Feature", pt: "Recurso" },
  "重要操作の変更履歴": { en: "Change history of key operations", pt: "Histórico de operações importantes" },
  "経費管理": { en: "Expenses", pt: "Despesas" },
  "経費を登録": { en: "Add Expense", pt: "Adicionar Despesa" },

  // ---- Statuses ----
  "入居中": { en: "Occupied", pt: "Ocupado" },
  "空室": { en: "Vacant", pt: "Vago" },
  "募集中": { en: "Listed", pt: "Anunciado" },
  "退去予定": { en: "Moving out", pt: "Saída prevista" },
  "修繕中": { en: "Under repair", pt: "Em reparo" },
  "有効": { en: "Active", pt: "Ativo" },
  "更新予定": { en: "Renewal due", pt: "Renovação" },
  "終了": { en: "Ended", pt: "Encerrado" },
  "未請求": { en: "Unbilled", pt: "Não faturado" },
  "請求済": { en: "Billed", pt: "Faturado" },
  "入金済": { en: "Paid", pt: "Pago" },
  "一部入金": { en: "Partial", pt: "Parcial" },
  "未入金": { en: "Unpaid", pt: "Não pago" },
  "受付": { en: "Received", pt: "Recebido" },
  "内容確認": { en: "Review", pt: "Revisão" },
  "見積": { en: "Quote", pt: "Orçamento" },
  "承認": { en: "Approved", pt: "Aprovado" },
  "発注": { en: "Ordered", pt: "Pedido" },
  "工事中": { en: "In progress", pt: "Em obra" },
  "完了": { en: "Completed", pt: "Concluído" },
  "支払済": { en: "Paid", pt: "Pago" },
  "低": { en: "Low", pt: "Baixa" },
  "中": { en: "Med", pt: "Média" },
  "高": { en: "High", pt: "Alta" },

  // ---- Property types / ownership / structure ----
  "アパート": { en: "Apartment", pt: "Apartamento" },
  "マンション": { en: "Mansion", pt: "Condomínio" },
  "戸建": { en: "House", pt: "Casa" },
  "店舗": { en: "Shop", pt: "Loja" },
  "事務所": { en: "Office", pt: "Escritório" },
  "土地": { en: "Land", pt: "Terreno" },
  "駐車場": { en: "Parking", pt: "Estacionamento" },
  "所有": { en: "Owned", pt: "Próprio" },
  "管理受託": { en: "Managed", pt: "Gerido" },
  "RC造": { en: "RC", pt: "RC" }, "鉄骨造": { en: "Steel", pt: "Aço" }, "木造": { en: "Wood", pt: "Madeira" }, "その他": { en: "Other", pt: "Outro" },

  // ---- Roles ----
  "システム管理者": { en: "System Admin", pt: "Admin do Sistema" },
  "会社管理者": { en: "Company Admin", pt: "Admin da Empresa" },
  "不動産管理担当": { en: "Property Manager", pt: "Gestor de Imóveis" },
  "経理担当": { en: "Accountant", pt: "Contador" },
  "閲覧ユーザー": { en: "Viewer", pt: "Visualizador" },

  // ---- Common field labels ----
  "物件名": { en: "Property name", pt: "Nome do imóvel" },
  "物件種別": { en: "Type", pt: "Tipo" },
  "種別": { en: "Type", pt: "Tipo" },
  "区分": { en: "Ownership", pt: "Posse" },
  "所有区分": { en: "Ownership", pt: "Posse" },
  "郵便番号": { en: "Postal code", pt: "CEP" },
  "所在地": { en: "Address", pt: "Endereço" },
  "住所": { en: "Address", pt: "Endereço" },
  "土地面積(㎡)": { en: "Land area (㎡)", pt: "Área do terreno (㎡)" },
  "建物面積(㎡)": { en: "Building area (㎡)", pt: "Área construída (㎡)" },
  "構造": { en: "Structure", pt: "Estrutura" },
  "階数": { en: "Floors", pt: "Andares" },
  "階": { en: "Floor", pt: "Andar" },
  "取得日": { en: "Acquired date", pt: "Data de aquisição" },
  "購入価格": { en: "Purchase price", pt: "Preço de compra" },
  "現在評価額": { en: "Current value", pt: "Valor atual" },
  "土地価格": { en: "Land price", pt: "Preço do terreno" },
  "建物価格": { en: "Building price", pt: "Preço do prédio" },
  "固定資産税": { en: "Property tax", pt: "IPTU" },
  "管理会社": { en: "Management company", pt: "Administradora" },
  "物件写真": { en: "Photo", pt: "Foto" },
  "備考": { en: "Notes", pt: "Observações" },
  "物件": { en: "Property", pt: "Imóvel" },
  "部屋番号": { en: "Room no.", pt: "Nº da unidade" },
  "間取り": { en: "Layout", pt: "Planta" },
  "面積": { en: "Area", pt: "Área" },
  "面積(㎡)": { en: "Area (㎡)", pt: "Área (㎡)" },
  "賃料": { en: "Rent", pt: "Aluguel" },
  "共益費": { en: "Common fee", pt: "Taxa comum" },
  "管理費": { en: "Mgmt fee", pt: "Taxa de gestão" },
  "駐車場料金": { en: "Parking fee", pt: "Estacionamento" },
  "その他費用": { en: "Other fees", pt: "Outras taxas" },
  "敷金": { en: "Deposit", pt: "Caução" },
  "礼金": { en: "Key money", pt: "Luvas" },
  "入居状況": { en: "Occupancy", pt: "Ocupação" },
  "入居者": { en: "Tenant", pt: "Inquilino" },
  "氏名": { en: "Name", pt: "Nome" },
  "フリガナ": { en: "Name (kana)", pt: "Nome (kana)" },
  "生年月日": { en: "Date of birth", pt: "Nascimento" },
  "電話番号": { en: "Phone", pt: "Telefone" },
  "電話": { en: "Phone", pt: "Telefone" },
  "メール": { en: "Email", pt: "E-mail" },
  "現住所": { en: "Current address", pt: "Endereço atual" },
  "勤務先": { en: "Employer", pt: "Empregador" },
  "国籍": { en: "Nationality", pt: "Nacionalidade" },
  "緊急連絡先": { en: "Emergency contact", pt: "Contato de emergência" },
  "保証人": { en: "Guarantor", pt: "Fiador" },
  "保証会社": { en: "Guarantee company", pt: "Empresa garantidora" },
  "契約番号": { en: "Contract no.", pt: "Nº do contrato" },
  "対象物件": { en: "Property", pt: "Imóvel" },
  "対象部屋": { en: "Room", pt: "Unidade" },
  "部屋": { en: "Room", pt: "Unidade" },
  "契約開始日": { en: "Start date", pt: "Início" },
  "契約終了日": { en: "End date", pt: "Término" },
  "契約期間": { en: "Term", pt: "Período" },
  "更新料": { en: "Renewal fee", pt: "Taxa de renovação" },
  "契約ステータス": { en: "Status", pt: "Situação" },
  "特記事項": { en: "Special notes", pt: "Observações" },
  "状態": { en: "Status", pt: "Situação" },
  "契約": { en: "Contract", pt: "Contrato" },
  "請求年月": { en: "Billing month", pt: "Mês da fatura" },
  "請求額": { en: "Amount", pt: "Valor" },
  "入金額": { en: "Paid", pt: "Pago" },
  "未収額": { en: "Balance", pt: "Saldo" },
  "支払期限": { en: "Due date", pt: "Vencimento" },
  "水道代": { en: "Water", pt: "Água" },
  "ステータス": { en: "Status", pt: "Situação" },
  "入金日": { en: "Paid date", pt: "Data do pagamento" },
  "入金方法": { en: "Method", pt: "Método" },
  "対象請求": { en: "Target invoice", pt: "Fatura" },
  "未収の請求を選択": { en: "Select an unpaid invoice", pt: "Selecione uma fatura pendente" },
  "銀行振込": { en: "Bank transfer", pt: "Transferência" },
  "現金": { en: "Cash", pt: "Dinheiro" },
  "クレジットカード": { en: "Credit card", pt: "Cartão" },
  "口座振替": { en: "Direct debit", pt: "Débito automático" },
  "滞納月": { en: "Month", pt: "Mês" },
  "滞納額": { en: "Amount", pt: "Valor" },
  "滞納日数": { en: "Days overdue", pt: "Dias em atraso" },
  "督促回数": { en: "Reminders", pt: "Cobranças" },
  "最終連絡": { en: "Last contact", pt: "Último contato" },
  "連絡方法": { en: "Method", pt: "Método" },
  "連絡日": { en: "Contact date", pt: "Data do contato" },
  "対応内容": { en: "Notes", pt: "Observações" },
  "書面": { en: "Letter", pt: "Carta" },
  "訪問": { en: "Visit", pt: "Visita" },
  "修繕内容": { en: "Description", pt: "Descrição" },
  "緊急度": { en: "Urgency", pt: "Urgência" },
  "業者": { en: "Vendor", pt: "Fornecedor" },
  "見積金額": { en: "Estimate", pt: "Orçamento" },
  "発注金額": { en: "Order amount", pt: "Valor do pedido" },
  "支払額": { en: "Paid amount", pt: "Valor pago" },
  "工事予定日": { en: "Scheduled date", pt: "Data prevista" },
  "完了日": { en: "Completion date", pt: "Data de conclusão" },
  "写真": { en: "Photo", pt: "Foto" },
  "完了写真": { en: "Completion photo", pt: "Foto de conclusão" },
  "会社名": { en: "Company", pt: "Empresa" },
  "担当者": { en: "Contact", pt: "Contato" },
  "対応工事": { en: "Services", pt: "Serviços" },
  "対応工事（カンマ区切り）": { en: "Services (comma-separated)", pt: "Serviços (separados por vírgula)" },
  "金融機関": { en: "Lender", pt: "Banco" },
  "借入日": { en: "Borrow date", pt: "Data do empréstimo" },
  "借入額": { en: "Principal", pt: "Principal" },
  "現在残高": { en: "Balance", pt: "Saldo" },
  "金利": { en: "Rate", pt: "Taxa" },
  "金利(%)": { en: "Rate (%)", pt: "Taxa (%)" },
  "固定・変動": { en: "Fixed/Variable", pt: "Fixo/Variável" },
  "返済期間(年)": { en: "Term (years)", pt: "Prazo (anos)" },
  "毎月返済額": { en: "Monthly payment", pt: "Parcela mensal" },
  "最終返済日": { en: "Final date", pt: "Data final" },
  "担保情報": { en: "Collateral", pt: "Garantia" },
  "固定": { en: "Fixed", pt: "Fixo" },
  "変動": { en: "Variable", pt: "Variável" },
  "回": { en: "#", pt: "#" },
  "返済額": { en: "Payment", pt: "Parcela" },
  "元金": { en: "Principal", pt: "Principal" },
  "利息": { en: "Interest", pt: "Juros" },
  "残高": { en: "Balance", pt: "Saldo" },
  "会社全体": { en: "Whole company", pt: "Empresa toda" },
  "総収入": { en: "Total income", pt: "Receita total" },
  "総支出": { en: "Total expense", pt: "Despesa total" },
  "キャッシュフロー": { en: "Cash flow", pt: "Fluxo de caixa" },
  "表面利回り": { en: "Gross yield", pt: "Rendimento bruto" },
  "実質利回り": { en: "Net yield", pt: "Rendimento líquido" },
  "家賃": { en: "Rent", pt: "Aluguel" },
  "合計": { en: "Total", pt: "Total" },
  "日付 (YYYY-MM-DD)": { en: "Date (YYYY-MM-DD)", pt: "Data (AAAA-MM-DD)" },
  "科目": { en: "Category", pt: "Categoria" },
  "金額": { en: "Amount", pt: "Valor" },
  "日付": { en: "Date", pt: "Data" },
  "ローン": { en: "Loan", pt: "Empréstimo" },
  "修繕": { en: "Repair", pt: "Reparo" },
  "保険": { en: "Insurance", pt: "Seguro" },
  "水道光熱費": { en: "Utilities", pt: "Utilidades" },
  "その他経費": { en: "Other", pt: "Outros" },
  "入力条件": { en: "Inputs", pt: "Parâmetros" },
  "諸費用": { en: "Costs", pt: "Custos" },
  "自己資金": { en: "Equity", pt: "Capital próprio" },
  "想定家賃(月)": { en: "Expected rent (mo)", pt: "Aluguel previsto (mês)" },
  "稼働率(%)": { en: "Occupancy (%)", pt: "Ocupação (%)" },
  "管理費(年)": { en: "Mgmt fee (yr)", pt: "Gestão (ano)" },
  "修繕費(年)": { en: "Repairs (yr)", pt: "Reparos (ano)" },
  "固定資産税(年)": { en: "Property tax (yr)", pt: "IPTU (ano)" },
  "保険料(年)": { en: "Insurance (yr)", pt: "Seguro (ano)" },
  "その他経費(年)": { en: "Other exp. (yr)", pt: "Outras desp. (ano)" },
  "年間返済額": { en: "Annual debt", pt: "Dívida anual" },
  "年間キャッシュフロー": { en: "Annual cash flow", pt: "Fluxo anual" },
  "投資回収期間": { en: "Payback period", pt: "Retorno" },
  "月次返済額": { en: "Monthly payment", pt: "Parcela mensal" },
  "稼働率別 年間キャッシュフロー": { en: "Annual cash flow by occupancy", pt: "Fluxo anual por ocupação" },

  // ---- Documents ----
  "タイトル・タグ・カテゴリで検索...": { en: "Search title, tags, category...", pt: "Buscar título, tags, categoria..." },
  "ダウンロード": { en: "Download", pt: "Baixar" },
  "未関連": { en: "Unlinked", pt: "Sem vínculo" },
  "ファイル": { en: "File", pt: "Arquivo" },
  "タイトル": { en: "Title", pt: "Título" },
  "カテゴリ": { en: "Category", pt: "Categoria" },
  "関連物件": { en: "Linked property", pt: "Imóvel vinculado" },
  "なし": { en: "None", pt: "Nenhum" },
  "タグ（カンマ区切り）": { en: "Tags (comma-separated)", pt: "Tags (separadas por vírgula)" },
  "アップロード": { en: "Upload", pt: "Enviar" },

  // ---- Users / settings ----
  "パスワード（変更する場合のみ）": { en: "Password (only to change)", pt: "Senha (apenas para alterar)" },
  "言語": { en: "Language", pt: "Idioma" },

  // ---- Notifications / emails ----
  "通知はありません": { en: "No notifications", pt: "Sem notificações" },
  "緊急": { en: "Urgent", pt: "Urgente" },
  "注意": { en: "Warning", pt: "Atenção" },
  "お知らせ": { en: "Info", pt: "Info" },
  "契約更新": { en: "Contract renewal", pt: "Renovação de contrato" },
  "家賃滞納": { en: "Rent arrears", pt: "Aluguel em atraso" },
  "ローン返済": { en: "Loan payment", pt: "Pagamento de empréstimo" },
  "契約更新リマインダーの送信履歴": { en: "Contract renewal email history", pt: "Histórico de e-mails de renovação" },
  "リマインダーを今すぐ送信": { en: "Send reminders now", pt: "Enviar lembretes agora" },
  "送信日時": { en: "Sent at", pt: "Enviado em" },
  "宛先": { en: "To", pt: "Para" },
  "件名": { en: "Subject", pt: "Assunto" },
  "送信済": { en: "Sent", pt: "Enviado" },
  "失敗": { en: "Failed", pt: "Falhou" },
  "プレビュー": { en: "Preview", pt: "Prévia" },
  "履歴がありません": { en: "No history", pt: "Sem histórico" },
  "リマインダーを送信しました": { en: "Reminders sent", pt: "Lembretes enviados" },

  // ---- Reports ----
  "年間総収入": { en: "Annual income", pt: "Receita anual" },
  "年間総支出": { en: "Annual expense", pt: "Despesa anual" },
  "年間CF": { en: "Annual CF", pt: "FC anual" },
  "月次 収入 / 支出": { en: "Monthly income / expense", pt: "Receita / despesa mensal" },
  "印刷 / PDF": { en: "Print / PDF", pt: "Imprimir / PDF" },
  "支出": { en: "Expense", pt: "Despesa" },

  // ---- AI ----
  "自然な日本語で物件データを問い合わせ（Phase 3で有効化）": { en: "Query your data in natural language (enabled in Phase 3)", pt: "Consulte seus dados em linguagem natural (Fase 3)" },
  "AIモデル未接続": { en: "AI model not connected", pt: "Modelo de IA não conectado" },
  "質問例": { en: "Examples", pt: "Exemplos" },
  "質問を入力...": { en: "Type a question...", pt: "Digite uma pergunta..." },

  // ---- Topbar search ----
  "物件・入居者・契約・書類などを検索...": { en: "Search properties, tenants, contracts, documents...", pt: "Buscar imóveis, inquilinos, contratos, documentos..." },

  // ---- Misc ----
  // ---- Landlord portal & SaaS menu ----
  "運営管理": { en: "Operations", pt: "Operações" },
  "貸主管理": { en: "Landlords", pt: "Proprietários" },
  "プラン・お支払い": { en: "Plan & Billing", pt: "Plano e pagamento" },
  "SaaS 運営管理": { en: "SaaS Operations", pt: "Operações SaaS" },
  "貸主ポータル": { en: "Landlord Portal", pt: "Portal do proprietário" },
  "貸主ログイン": { en: "Landlord Login", pt: "Login do proprietário" },
  "管理会社から発行されたコードと暗証番号でログインしてください。": { en: "Log in with the code and PIN issued by your management company.", pt: "Entre com o código e o PIN fornecidos pela administradora." },
  "ログインコード": { en: "Login code", pt: "Código de acesso" },
  "暗証番号（6桁）": { en: "PIN (6 digits)", pt: "PIN (6 dígitos)" },
  "ログアウト": { en: "Log out", pt: "Sair" },
  "プロフィール": { en: "Profile", pt: "Perfil" },
  "フロントページに戻る": { en: "Back to home", pt: "Voltar ao início" },
  "貸主情報の登録・所有物件の確認ができます。": { en: "Register landlord details and view owned properties.", pt: "Registre os dados do proprietário e veja os imóveis." },
  "所有物件": { en: "Owned properties", pt: "Imóveis" },
  "借主ポータル": { en: "Tenant Portal", pt: "Portal do inquilino" },
  "契約・電子契約": { en: "Contracts", pt: "Contratos" },
  "家賃・お支払い": { en: "Rent & Payments", pt: "Aluguel e pagamentos" },
  "修繕・不具合": { en: "Repairs", pt: "Reparos" },
  "書類": { en: "Documents", pt: "Documentos" },
  "お問い合わせ": { en: "Contact", pt: "Contato" },
  "マイポータル": { en: "My Portal", pt: "Meu portal" },
  "契約・家賃・修繕・書類をオンラインで管理できます。": { en: "Manage contracts, rent, repairs and documents online.", pt: "Gerencie contratos, aluguel, reparos e documentos online." },
  "プロフィールの入力が完了していません": { en: "Your profile is incomplete", pt: "Seu perfil está incompleto" },
  "プロフィール未入力のお知らせ": { en: "Incomplete profile notice", pt: "Aviso de perfil incompleto" },
  "入力する": { en: "Fill in", pt: "Preencher" },
  "後で": { en: "Later", pt: "Mais tarde" },
  "プロフィールを入力する": { en: "Complete profile", pt: "Completar perfil" },

  // ---- Registration wizard: chrome & common ----
  "個人登録": { en: "Individual Registration", pt: "Cadastro Pessoa Física" },
  "法人登録": { en: "Corporate Registration", pt: "Cadastro Pessoa Jurídica" },
  "法人に切替": { en: "Switch to corporate", pt: "Mudar para PJ" },
  "個人に切替": { en: "Switch to individual", pt: "Mudar para PF" },
  "入力完了率": { en: "Completion", pt: "Preenchimento" },
  "選択": { en: "Select", pt: "Selecione" },
  "必須項目です": { en: "Required", pt: "Obrigatório" },
  "未登録": { en: "None added", pt: "Nenhum registro" },
  "未入力": { en: "Not entered", pt: "Não preenchido" },
  "プロフィール情報を自動反映しています": { en: "Your profile information is auto-filled", pt: "As informações do seu perfil são preenchidas automaticamente" },
  "内容の修正はプロフィールから行ってください。": { en: "To edit, please update your profile.", pt: "Para editar, atualize seu perfil." },
  "プロフィールを修正": { en: "Edit profile", pt: "Editar perfil" },
  "以下の項目が未入力です": { en: "The following items are missing", pt: "Os seguintes itens estão faltando" },
  "プロフィールの入力が不足しています": { en: "Your profile is incomplete", pt: "Seu perfil está incompleto" },
  "契約内容への同意が必要です": { en: "You must agree to the contract", pt: "Você deve concordar com o contrato" },
  "上記の契約内容とプロフィール情報を確認し、同意します。": { en: "I have reviewed the contract and profile information above and agree.", pt: "Revisei o contrato e as informações do perfil acima e concordo." },
  "署名して提出する": { en: "Sign and submit", pt: "Assinar e enviar" },
  "署名が確定しました。内容は編集できません。": { en: "Your signature is finalized. This cannot be edited.", pt: "Sua assinatura foi finalizada. Não pode ser editada." },
  "契約条件（重要事項）": { en: "Contract Terms (Key Points)", pt: "Termos do Contrato (Pontos-Chave)" },
  "契約期間": { en: "Contract period", pt: "Período do contrato" },
  "支払方法・振込先": { en: "Payment method / bank transfer", pt: "Forma de pagamento / transferência" },
  "全契約に表示": { en: "shown on all contracts", pt: "exibido em todos os contratos" },
  "支払方法": { en: "Payment method", pt: "Forma de pagamento" },
  "銀行名": { en: "Bank name", pt: "Banco" },
  "支店名": { en: "Branch", pt: "Agência" },
  "預金種別": { en: "Account type", pt: "Tipo de conta" },
  "口座番号": { en: "Account no.", pt: "Nº da conta" },
  "口座名義": { en: "Account holder", pt: "Titular" },
  "支払期日": { en: "Payment due", pt: "Vencimento" },
  "遅延損害金率": { en: "Late-fee rate", pt: "Taxa de mora" },
  "遅延損害金": { en: "Late-payment damages", pt: "Encargos por atraso" },
  "振込先": { en: "Bank transfer to", pt: "Transferir para" },
  "補足事項": { en: "Additional notes", pt: "Observações adicionais" },
  "任意": { en: "optional", pt: "opcional" },
  "銀行振込": { en: "Bank transfer", pt: "Transferência bancária" },
  "口座振替": { en: "Direct debit", pt: "Débito automático" },
  "普通": { en: "Ordinary", pt: "Comum" },
  "当座": { en: "Current", pt: "Corrente" },
  "入力した内容は全契約の重要事項・契約書PDFに表示されます。": { en: "This is shown in the key terms and contract PDF of all contracts.", pt: "Isto aparece nos termos-chave e no PDF de todos os contratos." },
  "特約・注意事項": { en: "Special terms / notes", pt: "Termos especiais / observações" },
  "契約条項": { en: "Contract clauses", pt: "Cláusulas do contrato" },
  "お支払い方法は管理会社よりご案内します。": { en: "Payment details will be provided by the management company.", pt: "Os detalhes de pagamento serão fornecidos pela administradora." },
  "上記の契約条件（重要事項）を確認しました。": { en: "I have reviewed the contract terms (key points) above.", pt: "Revisei os termos do contrato (pontos-chave) acima." },
  "契約条件（重要事項）の確認が必要です": { en: "You must confirm the contract terms", pt: "Você deve confirmar os termos do contrato" },
  "駐車場料金": { en: "Parking fee", pt: "Taxa de estacionamento" },
  "その他費用": { en: "Other fees", pt: "Outras taxas" },
  "更新料": { en: "Renewal fee", pt: "Taxa de renovação" },
  "【契約期間・更新】契約期間は上記のとおりとし、期間満了時は協議のうえ更新できます。": { en: "[Term/Renewal] The term is as above; it may be renewed by mutual agreement at expiry.", pt: "[Prazo/Renovação] O prazo é o indicado acima; pode ser renovado por acordo mútuo no vencimento." },
  "【支払方法・支払期日】賃料等は毎月定められた期日までに、下記の方法でお支払いください。": { en: "[Payment method/due date] Please pay rent by the set date each month via the method below.", pt: "[Forma/vencimento] Pague o aluguel até a data definida a cada mês pelo método abaixo." },
  "【遅延損害金】支払を遅延した場合、年14.6%の割合による遅延損害金が発生することがあります。": { en: "[Late charges] Late payments may incur late-payment damages at 14.6% per annum.", pt: "[Encargos por atraso] Pagamentos em atraso podem gerar encargos de 14,6% ao ano." },
  "【解約予告】解約する場合は、原則として1ヶ月前までに管理会社へご通知ください。": { en: "[Cancellation notice] To cancel, notify the management company at least 1 month in advance.", pt: "[Aviso de rescisão] Para cancelar, avise a administradora com pelo menos 1 mês de antecedência." },
  "【原状回復】退去時は、通常損耗を除き、借主の故意・過失による損傷の原状回復義務を負います。": { en: "[Restoration] On move-out, tenant must restore damage from intent/negligence, excluding normal wear.", pt: "[Restauração] Na saída, o inquilino deve reparar danos por dolo/negligência, exceto desgaste normal." },
  "【禁止事項】無断転貸・用法違反・近隣への迷惑行為等を禁止します。": { en: "[Prohibited acts] Unauthorized subletting, misuse, and nuisance to neighbors are prohibited.", pt: "[Atos proibidos] Sublocação não autorizada, uso indevido e perturbação aos vizinhos são proibidos." },
  "【保証】連帯保証人または保証会社のご利用が必要となる場合があります。": { en: "[Guarantee] A joint guarantor or a guarantee company may be required.", pt: "[Garantia] Pode ser exigido um fiador solidário ou uma empresa garantidora." },
  "追加": { en: "Add", pt: "Adicionar" },
  "アップロード済": { en: "Uploaded", pt: "Enviado" },
  "住所検索": { en: "Lookup", pt: "Buscar" },
  "下書き保存": { en: "Save draft", pt: "Salvar rascunho" },
  "戻る": { en: "Back", pt: "Voltar" },
  "次へ": { en: "Next", pt: "Próximo" },
  "登録する": { en: "Register", pt: "Cadastrar" },
  "読み込みに失敗しました。": { en: "Failed to load.", pt: "Falha ao carregar." },
  "取得": { en: "Fetch", pt: "Buscar" },

  // ---- Wizard step labels ----
  "基本情報": { en: "Basic Info", pt: "Dados básicos" },
  "連絡先": { en: "Contact", pt: "Contato" },
  "現住所": { en: "Address", pt: "Endereço" },
  "役割・区分": { en: "Role & Type", pt: "Função e tipo" },
  "勤務先・収入": { en: "Employer & Income", pt: "Emprego e renda" },
  "保証人・保証会社": { en: "Guarantor", pt: "Fiador" },
  "口座情報": { en: "Bank Account", pt: "Conta bancária" },
  "提出書類": { en: "Documents", pt: "Documentos" },
  "確認": { en: "Confirm", pt: "Confirmação" },
  "法人基本情報": { en: "Company Info", pt: "Dados da empresa" },
  "本店所在地": { en: "Head Office", pt: "Sede" },
  "代表者情報": { en: "Representative", pt: "Representante" },
  "事業情報": { en: "Business Info", pt: "Negócio" },
  "役員情報": { en: "Officers", pt: "Diretores" },
  "株主・出資者情報": { en: "Shareholders", pt: "Acionistas" },
  "実質的支配者情報": { en: "Beneficial Owners", pt: "Beneficiários finais" },
  "法人口座情報": { en: "Bank Account", pt: "Conta bancária" },
  "税務・登録情報": { en: "Tax & Registration", pt: "Tributário e registro" },

  // ---- Wizard field labels ----
  "性別": { en: "Gender", pt: "Sexo" },
  "FAX番号": { en: "Fax", pt: "Fax" },
  "LINE ID": { en: "LINE ID", pt: "LINE ID" },
  "WhatsApp番号": { en: "WhatsApp", pt: "WhatsApp" },
  "住居区分": { en: "Residence type", pt: "Tipo de moradia" },
  "居住年数": { en: "Years at address", pt: "Anos no endereço" },
  "勤務先名": { en: "Employer", pt: "Empregador" },
  "部署": { en: "Department", pt: "Departamento" },
  "役職": { en: "Title", pt: "Cargo" },
  "雇用形態": { en: "Employment type", pt: "Tipo de emprego" },
  "勤務先電話番号": { en: "Employer phone", pt: "Tel. do empregador" },
  "勤続年数": { en: "Years employed", pt: "Anos de serviço" },
  "年収（円）": { en: "Annual income (JPY)", pt: "Renda anual (JPY)" },
  "続柄": { en: "Relationship", pt: "Parentesco" },
  "連帯保証人 氏名": { en: "Guarantor name", pt: "Nome do fiador" },
  "連帯保証人": { en: "Guarantor", pt: "Fiador" },
  "保証会社名": { en: "Guarantee company", pt: "Empresa garantidora" },
  "保証番号": { en: "Guarantee number", pt: "Número da garantia" },
  "身分証明書": { en: "ID document", pt: "Documento de identidade" },
  "その他書類": { en: "Other documents", pt: "Outros documentos" },
  "登録担当者": { en: "Registrar", pt: "Responsável pelo cadastro" },
  "担当者氏名": { en: "Registrar name", pt: "Nome do responsável" },
  "この個人の役割": { en: "Roles of this person", pt: "Funções desta pessoa" },
  "1件のマスター登録で、所有者・入居者・保証人など複数の役割を保持できます。": { en: "A single master record can hold multiple roles such as owner, tenant and guarantor.", pt: "Um único cadastro pode ter várias funções, como proprietário, inquilino e fiador." },
  "入力内容を確認しました": { en: "I have reviewed the information", pt: "Revisei as informações" },
  "利用規約・プライバシーポリシーに同意します": { en: "I agree to the Terms and Privacy Policy", pt: "Concordo com os Termos e a Política de Privacidade" },

  // ---- ZipRow labels ----
  "都道府県": { en: "Prefecture", pt: "Província" },
  "市区町村": { en: "City/Ward", pt: "Cidade" },
  "番地": { en: "Street address", pt: "Logradouro" },
  "建物名・部屋番号": { en: "Building / Room", pt: "Prédio / Unidade" },
  "代表者郵便番号": { en: "Rep. postal code", pt: "CEP do representante" },
  "代表者都道府県": { en: "Rep. prefecture", pt: "Província do representante" },
  "代表者市区町村": { en: "Rep. city/ward", pt: "Cidade do representante" },
  "代表者番地": { en: "Rep. street address", pt: "Logradouro do representante" },
  "代表者建物名・部屋番号": { en: "Rep. building/room", pt: "Prédio/unidade do representante" },

  // ---- Repeat cols ----
  "金融機関名": { en: "Bank name", pt: "Banco" },
  "金融機関コード": { en: "Bank code", pt: "Código do banco" },
  "支店名": { en: "Branch name", pt: "Agência" },
  "支店コード": { en: "Branch code", pt: "Código da agência" },
  "預金種別": { en: "Account type", pt: "Tipo de conta" },
  "口座番号": { en: "Account number", pt: "Número da conta" },
  "口座名義": { en: "Account holder", pt: "Titular" },
  "口座名義カナ": { en: "Holder (kana)", pt: "Titular (kana)" },
  "書類種類": { en: "Document type", pt: "Tipo de documento" },
  "書類名": { en: "Document name", pt: "Nome do documento" },
  "発行日": { en: "Issue date", pt: "Data de emissão" },
  "有効期限": { en: "Expiry", pt: "Validade" },
  "確認状態": { en: "Status", pt: "Status" },

  // ---- Options: individual ----
  "男性": { en: "Male", pt: "Masculino" },
  "女性": { en: "Female", pt: "Feminino" },
  "回答しない": { en: "Prefer not to say", pt: "Prefiro não dizer" },
  "持ち家": { en: "Owned home", pt: "Casa própria" },
  "賃貸": { en: "Rented", pt: "Alugado" },
  "社宅・寮": { en: "Company housing", pt: "Moradia da empresa" },
  "家族所有": { en: "Family-owned", pt: "Da família" },
  "正社員": { en: "Full-time", pt: "Efetivo" },
  "契約社員": { en: "Contract", pt: "Contrato" },
  "派遣社員": { en: "Dispatch", pt: "Temporário" },
  "パート・アルバイト": { en: "Part-time", pt: "Meio período" },
  "自営業": { en: "Self-employed", pt: "Autônomo" },
  "会社役員": { en: "Executive", pt: "Diretor" },
  "年金受給": { en: "Pensioner", pt: "Aposentado" },
  "学生": { en: "Student", pt: "Estudante" },
  "無職": { en: "Unemployed", pt: "Desempregado" },
  "普通": { en: "Ordinary", pt: "Corrente" },
  "当座": { en: "Checking", pt: "Conta corrente" },
  "本人確認書類(表)": { en: "ID (front)", pt: "Documento (frente)" },
  "本人確認書類(裏)": { en: "ID (back)", pt: "Documento (verso)" },
  "住民票": { en: "Residence certificate", pt: "Comprovante de residência" },
  "収入証明書": { en: "Income certificate", pt: "Comprovante de renda" },
  "在職証明書": { en: "Employment certificate", pt: "Comprovante de emprego" },
  "印鑑証明書": { en: "Seal certificate", pt: "Certificado de carimbo" },
  "提出済": { en: "Submitted", pt: "Enviado" },
  "確認中": { en: "Reviewing", pt: "Em análise" },
  "差戻し": { en: "Returned", pt: "Devolvido" },
  "期限切れ": { en: "Expired", pt: "Vencido" },
  "代理人": { en: "Agent", pt: "Procurador" },

  // ---- Options: corporate ----
  "株式会社": { en: "Co., Ltd. (KK)", pt: "S.A. (KK)" },
  "合同会社": { en: "LLC (GK)", pt: "LLC (GK)" },
  "合名会社": { en: "General partnership", pt: "Soc. em nome coletivo" },
  "合資会社": { en: "Limited partnership", pt: "Soc. em comandita" },
  "一般社団法人": { en: "General incorporated association", pt: "Associação incorporada" },
  "一般財団法人": { en: "General incorporated foundation", pt: "Fundação incorporada" },
  "社会福祉法人": { en: "Social welfare corporation", pt: "Corp. de bem-estar social" },
  "医療法人": { en: "Medical corporation", pt: "Corp. médica" },
  "NPO法人": { en: "NPO", pt: "ONG" },
  "代表取締役社長": { en: "President & CEO", pt: "Presidente e CEO" },
  "代表取締役": { en: "Representative Director", pt: "Diretor representante" },
  "取締役": { en: "Director", pt: "Diretor" },
  "代表社員": { en: "Managing partner", pt: "Sócio-gerente" },
  "理事長": { en: "Chairman", pt: "Presidente do conselho" },
  "会長": { en: "Chairperson", pt: "Presidente" },
  "代表者": { en: "Representative", pt: "Representante" },
  "株式保有による支配": { en: "Control via shareholding", pt: "Controle por ações" },
  "議決権による支配": { en: "Control via voting rights", pt: "Controle por voto" },
  "出資による支配": { en: "Control via investment", pt: "Controle por investimento" },
  "その他の支配関係": { en: "Other control", pt: "Outro controle" },
  "履歴事項全部証明書": { en: "Certificate of registered matters", pt: "Certidão de registro" },
  "法人印鑑証明書": { en: "Corporate seal certificate", pt: "Certificado de carimbo da empresa" },
  "定款": { en: "Articles of incorporation", pt: "Estatuto social" },
  "代表者本人確認書類": { en: "Representative ID", pt: "Documento do representante" },
  "銀行口座確認資料": { en: "Bank account proof", pt: "Comprovante bancário" },
  "許認可証": { en: "License certificate", pt: "Licença" },

  // ---- Corporate field labels ----
  "法人名（正式名称）": { en: "Company name (legal)", pt: "Razão social" },
  "法人名フリガナ": { en: "Company name (kana)", pt: "Nome (kana)" },
  "法人名英語表記": { en: "Company name (English)", pt: "Nome (inglês)" },
  "法人種別": { en: "Corporate type", pt: "Tipo de PJ" },
  "法人番号13桁": { en: "Corporate No. (13 digits)", pt: "Nº corporativo (13 díg.)" },
  "設立年月日": { en: "Establishment date", pt: "Data de fundação" },
  "資本金": { en: "Capital", pt: "Capital" },
  "決算月": { en: "Fiscal month", pt: "Mês fiscal" },
  "WebサイトURL": { en: "Website URL", pt: "Site" },
  "法人メールアドレス": { en: "Company email", pt: "E-mail da empresa" },
  "姓": { en: "Last name", pt: "Sobrenome" },
  "名": { en: "First name", pt: "Nome" },
  "姓フリガナ": { en: "Last name (kana)", pt: "Sobrenome (kana)" },
  "名フリガナ": { en: "First name (kana)", pt: "Nome (kana)" },
  "法人所在地と代表者住所が同じ": { en: "Representative address same as head office", pt: "Endereço do representante igual à sede" },
  "主たる事業内容": { en: "Main business", pt: "Atividade principal" },
  "業種": { en: "Industry", pt: "Setor" },
  "営業開始年月": { en: "Business start", pt: "Início das atividades" },
  "従業員数": { en: "Employees", pt: "Funcionários" },
  "営業時間": { en: "Business hours", pt: "Horário" },
  "営業地域": { en: "Service area", pt: "Área de atuação" },
  "許認可の有無": { en: "Has licenses?", pt: "Possui licenças?" },
  "あり": { en: "Yes", pt: "Sim" },
  "なし": { en: "No", pt: "Não" },
  "許認可": { en: "Licenses", pt: "Licenças" },
  "許認可名称": { en: "License name", pt: "Nome da licença" },
  "許認可番号": { en: "License number", pt: "Número da licença" },
  "適格請求書発行事業者登録番号": { en: "Invoice registration number", pt: "Nº de registro de fatura" },
  "形式は「T＋13桁」です": { en: "Format is 'T + 13 digits'", pt: "Formato: 'T + 13 dígitos'" },
  "管轄税務署": { en: "Tax office", pt: "Repartição fiscal" },
  "年金事務所": { en: "Pension office", pt: "Órgão previdenciário" },
  "労働保険番号": { en: "Labor insurance no.", pt: "Nº seguro trabalhista" },
  "雇用保険事業所番号": { en: "Employment insurance no.", pt: "Nº seguro-desemprego" },
  "代表者写真": { en: "Representative photo", pt: "Foto do representante" },
  "身分証明書（代表者）": { en: "ID (representative)", pt: "Documento (representante)" },
  "履歴事項全部証明書（1枚以上）": { en: "Certificate of registered matters (1+)", pt: "Certidão de registro (1+)" },
  "役員": { en: "Officers", pt: "Diretores" },
  "代表者からコピー": { en: "Copy from representative", pt: "Copiar do representante" },
  "株主・出資者": { en: "Shareholders", pt: "Acionistas" },
  "株主からコピー": { en: "Copy from shareholder", pt: "Copiar do acionista" },
  "実質的支配者": { en: "Beneficial owners", pt: "Beneficiários finais" },
  "法人口座": { en: "Corporate accounts", pt: "Contas da empresa" },
  "就任年月日": { en: "Appointment date", pt: "Data de nomeação" },
  "氏名／法人名": { en: "Name / Company", pt: "Nome / Empresa" },
  "保有株式数": { en: "Shares held", pt: "Ações" },
  "持株比率(%)": { en: "Shareholding (%)", pt: "Participação (%)" },
  "議決権比率(%)": { en: "Voting rights (%)", pt: "Direito de voto (%)" },
  "支配関係": { en: "Control relationship", pt: "Relação de controle" },
  "持株・議決権割合(%)": { en: "Shareholding/voting (%)", pt: "Ações/votos (%)" },
  "株主が未登録です": { en: "No shareholders registered", pt: "Nenhum acionista registrado" },
  "registrar_dept_placeholder": { en: "", pt: "" },

  // ---- Wizard toasts ----
  "保存に失敗しました": { en: "Failed to save", pt: "Falha ao salvar" },
  "郵便番号は7桁で入力してください": { en: "Enter a 7-digit postal code", pt: "Insira um CEP de 7 dígitos" },
  "住所が見つかりませんでした": { en: "Address not found", pt: "Endereço não encontrado" },
  "住所を自動入力しました": { en: "Address auto-filled", pt: "Endereço preenchido" },
  "住所取得に失敗しました": { en: "Failed to get address", pt: "Falha ao obter endereço" },
  "アップロードしました": { en: "Uploaded", pt: "Enviado" },
  "確認・同意にチェックしてください": { en: "Please check confirmation and agreement", pt: "Marque confirmação e concordância" },
  "役割を1つ以上選択してください": { en: "Select at least one role", pt: "Selecione ao menos uma função" },
  "このステップの必須項目を入力してください": { en: "Fill required fields in this step", pt: "Preencha os campos obrigatórios desta etapa" },
  "前のステップを順番に入力してください": { en: "Complete previous steps in order", pt: "Complete as etapas anteriores em ordem" },
  "個人情報を登録しました": { en: "Individual info registered", pt: "Dados pessoais cadastrados" },
  "未入力の必須項目があります": { en: "Some required fields are empty", pt: "Há campos obrigatórios vazios" },
  "法人番号は13桁で入力してください": { en: "Enter a 13-digit corporate number", pt: "Insira o número corporativo de 13 dígitos" },
  "会社情報を取得しました": { en: "Company info retrieved", pt: "Dados da empresa obtidos" },
  "取得に失敗しました": { en: "Failed to retrieve", pt: "Falha ao obter" },
  "法人情報を登録しました": { en: "Corporate info registered", pt: "Dados da PJ cadastrados" },

  // ---- Photo capture & camera ----
  "画像ファイルを選択してください": { en: "Please select an image file", pt: "Selecione um arquivo de imagem" },
  "写真を追加しました": { en: "Photo added", pt: "Foto adicionada" },
  "アップロードに失敗しました": { en: "Upload failed", pt: "Falha no envio" },
  "撮影": { en: "Capture", pt: "Capturar" },
  "在留カード": { en: "Residence card", pt: "Cartão de residência" },
  "運転免許証": { en: "Driver's license", pt: "CNH" },
  "マイナンバーカード": { en: "My Number card", pt: "Cartão My Number" },
  "本人確認書類を選択し、表面・裏面を撮影またはアップロードしてください。": { en: "Select your ID and capture or upload the front and back.", pt: "Selecione seu documento e capture ou envie a frente e o verso." },
  "書類の種類を選択してください": { en: "Please select a document type", pt: "Selecione o tipo de documento" },
  "表面": { en: "Front", pt: "Frente" },
  "裏面": { en: "Back", pt: "Verso" },
  "写真を撮る / 追加": { en: "Take / add photo", pt: "Tirar / adicionar foto" },
  "顔写真": { en: "Face photo", pt: "Foto do rosto" },
  "そのまま静止してください": { en: "Hold still", pt: "Fique parado" },
  "枠内に顔を合わせてください": { en: "Fit your face in the frame", pt: "Encaixe o rosto na moldura" },
  "枠内にカードを合わせてください": { en: "Fit the card in the frame", pt: "Encaixe o cartão na moldura" },
  "自動": { en: "Auto", pt: "Auto" },

  // ---- Landlords (admin) ----
  "コード": { en: "Code", pt: "Código" },
  "貸主名": { en: "Landlord name", pt: "Nome do proprietário" },
  "ポータル": { en: "Portal", pt: "Portal" },
  "未設定": { en: "Not set", pt: "Não definido" },
  "物件オーナー（貸主）の一覧・登録": { en: "List and register property owners (landlords)", pt: "Listar e cadastrar proprietários" },
  "貸主を登録": { en: "Add Landlord", pt: "Adicionar proprietário" },
  "貸主一覧へ戻る": { en: "Back to landlords", pt: "Voltar aos proprietários" },
  "貸主が見つかりません": { en: "Landlord not found", pt: "Proprietário não encontrado" },
  "法人名": { en: "Company name", pt: "Razão social" },
  "法人番号": { en: "Corporate number", pt: "Número corporativo" },
  "ポータルログイン": { en: "Portal login", pt: "Login do portal" },
  "暗証番号を設定 / リセット（6桁）": { en: "Set / reset PIN (6 digits)", pt: "Definir / redefinir PIN (6 dígitos)" },
  "6桁の数字": { en: "6-digit number", pt: "6 dígitos" },
  "設定": { en: "Set", pt: "Definir" },
  "設定後、貸主は「/landlord/login」からコードと暗証番号でログインし、詳細情報を自己登録できます。": { en: "After setup, the landlord can log in at '/landlord/login' with the code and PIN to self-register their details.", pt: "Após a configuração, o proprietário pode entrar em '/landlord/login' com o código e o PIN para se cadastrar." },
  "物件管理で物件の「貸主」に本貸主を設定すると、ここに表示されます。": { en: "Properties appear here once you set this landlord as the property's 'landlord' in Property management.", pt: "Os imóveis aparecem aqui quando você define este proprietário no imóvel." },
  "暗証番号は6桁で入力してください": { en: "Enter a 6-digit PIN", pt: "Insira um PIN de 6 dígitos" },
  "暗証番号を設定しました。貸主ポータルにログインできます。": { en: "PIN set. The landlord can now log in to the portal.", pt: "PIN definido. O proprietário já pode acessar o portal." },

  // ---- Nationalities ----
  "日本": { en: "Japan", pt: "Japão" },
  "中国": { en: "China", pt: "China" },
  "韓国": { en: "South Korea", pt: "Coreia do Sul" },
  "ベトナム": { en: "Vietnam", pt: "Vietnã" },
  "フィリピン": { en: "Philippines", pt: "Filipinas" },
  "ブラジル": { en: "Brazil", pt: "Brasil" },
  "ネパール": { en: "Nepal", pt: "Nepal" },
  "インドネシア": { en: "Indonesia", pt: "Indonésia" },
  "ペルー": { en: "Peru", pt: "Peru" },
  "タイ": { en: "Thailand", pt: "Tailândia" },
  "ミャンマー": { en: "Myanmar", pt: "Mianmar" },
  "台湾": { en: "Taiwan", pt: "Taiwan" },
  "アメリカ合衆国": { en: "United States", pt: "Estados Unidos" },
  "イギリス": { en: "United Kingdom", pt: "Reino Unido" },
  "インド": { en: "India", pt: "Índia" },
  "スリランカ": { en: "Sri Lanka", pt: "Sri Lanka" },
  "バングラデシュ": { en: "Bangladesh", pt: "Bangladesh" },
  "入居者一覧へ戻る": { en: "Back to tenants", pt: "Voltar aos inquilinos" },
  "編集中": { en: "Editing", pt: "Editando" },
  "メッセージ": { en: "Messages", pt: "Mensagens" },
  "メッセージはまだありません。": { en: "No messages yet.", pt: "Ainda não há mensagens." },
  "返信を入力...": { en: "Type a reply...", pt: "Digite uma resposta..." },
  "写真（任意）": { en: "Photos (optional)", pt: "Fotos (opcional)" },
  "契約書": { en: "Contract", pt: "Contrato" },
  "契約書PDF": { en: "Contract PDF", pt: "PDF do contrato" },
};
